// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import {getTwigs, getSubscriptionDetails, cancelStripeSubscription, initializeStripe} from './Api';
import { convertToISO } from '../utils/Utility';
import { showLoader, INITIALIZE_STRIPE } from './actions';

var _ = require('lodash');

export const GET_SUBSCRIPTION_HISTORY = "GET_SUBSCRIPTION_HISTORY";
export const SAVE_TWIG_IN_SESSION = "SAVE_TWIG_IN_SESSION";
export const CONFIRM_CANCELLATION = "CONFIRM_CANCELLATION";
export const CLOSE_CONFIRMATION = "CLOSE_CONFIRMATION";

export function getSubscriptionHistory () {
    return (dispatch => {
        initializeStripe().then(response => {
            dispatch({
                type: INITIALIZE_STRIPE,
                result: response
            });
            getTwigs('').then(twigs => {
                getSubscriptionDetails().then(data => {
                    dispatch({
                        type :GET_SUBSCRIPTION_HISTORY,
                        result: {data, twigs}
                    });
                });
            });
        });
    });
}

export function cancelSubscription(subscription){
    return (dispatch => {
        cancelStripeSubscription(subscription).then(response => {
            if(response) {
                dispatch(getSubscriptionHistory());
            }
        })
        .catch(error => {reject(error);});
    });
}

export function saveTwigInSession(data) {
    return (dispatch => {
        dispatch({
            type :SAVE_TWIG_IN_SESSION,
            result: data
        });
    });
}

export function confirmCancellation(data) {
    return (dispatch => {
        dispatch({
            type :CONFIRM_CANCELLATION,
            result: {
                data : data,
                success: true
            }
        });
    });
}

export function closeConfirmation (value) {
    return (dispatch => {
        dispatch({
            type :CLOSE_CONFIRMATION,
            result: value
        });
    });
}



// WEBPACK FOOTER //
// ./src/js/actions/subscriptionView.js